<template>
    <div>
        <slot v-bind="{ name, organisation, avatar }">
            <div v-bind="$attrs" class="flex items-center leading-tight">
                <UiAvatar :name="name" :image="avatar" class="mr-[0.5em]" />
                <span>
                    {{ name }}<br />
                    <span v-text="organisation" class="text-gray-500" />
                </span>
            </div>
        </slot>
    </div>
</template>

<script lang="ts" setup>
    const props = defineProps<{
        member: ApiModel<'MemberData'> | ApiModel<'ExternalPerson'>
    }>()

    const { $fullName } = useNuxtApp()

    const name = computed(() => {
        // if member is deleted form the system then firstName and lastName properties are null
        // then we want to return deleted person
        const nameToCheck = $fullName(props.member)
        return nameToCheck.trim() !== "" ? nameToCheck : "Gelöschte Person"
    })

    const organisation = computed(() => {
        if (props.member instanceof useModelFactory('MemberData')) {
            return props.member.leadingOrganisation?.name
        }
        if (props.member) {
            // extract Organisation from registrationcard remark
            // this is necessary beacause the organisation is not delivered by the backend for external personal
            // the remark is filled by the backend in a specific format
            const remark = (props.member as ApiModel<'ExternalPerson'>).remark
            if (remark) {
                const match = remark.match(/Gemeinschaft:\s*([^,]+),\s*Einsatzort:/)
                if (match && match[1]?.trim()) {
                    return `extern: ${match[1].trim()}`
                }
            }
            return 'Extern Mitwirkende*r'
        }
        return ''
    })

    const avatar = computed(() => {
        if(props.member instanceof useModelFactory('MemberData')){
            const { avatar } = props.member
            return !!avatar ? `data:image/png;base64, ${avatar}` : null
        }

        return null
    })
</script>
